import "./registrationDetailsHit.css";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import { UPLOAD_DCUMENT, authKey, ResourceUpdateMember } from '../../../../common/URLs';
import moment from 'moment';
import { VehiclePopupHit } from "./vehiclePopupHit";
import IconButton from '@mui/material/IconButton';
import { DriverPopupHit } from "./driverPopupHit";
import { Button, Switch, Divider, Card, CardContent, ToggleButton, ToggleButtonGroup, FormGroup, FormControlLabel, Checkbox, Stack, Box, Typography, Grid, FormHelperText, FormControl, InputLabel, Select, MenuItem, TextField, FormLabel, Tooltip } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { QuickSearchToolbar } from "../../../../payment/common/commonFunctions";
import { checkDateValidation, VALIDATION } from "../../../../common/commonValidations";
import { API_DATE_FORMAT, BASIC_DATE_FORMAT, DATE_RANGE_ERROR, EMPTY_FIELD_ERROR, UPLOAD_FILE_TEXT } from "../../../../common/constants";
import Preview from '../../registration/preview';
import { DialogContent, Dialog } from '@mui/material';
import { PROD } from "../../../../common/constants";
import { FileUploadMUI } from "../../../../common/fileUpload/fileUploadMUI";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { useTranslation } from "react-i18next";
import { ConfirmationPopover } from "../../../../common/commonPopovers/confirmationPopover";
import { useHitContextData } from "./registrationDetailsHit";
import { CheckCircle as TickIcon, Add as AddIcon, Delete as DeleteIcon , Cancel as CrossIcon, ArrowForwardIosSharp as AccordionIcon } from '@mui/icons-material';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Badge from 'react-bootstrap/Badge';
import { toast } from 'react-toastify';
import { insertComment } from '../commonRegistrationStakeholderAPIs';
import jwt from 'jwt-decode';
import { getLocalStorageItem } from "../../../../common/localStorageUtils";
import { EditIcon, SaveIcon } from "../../../../common/icons";
import CommentIcon from '@mui/icons-material/Comment';

const AgencyDetails = () => {
    const { userType, viewOnly, hitDetails, basicHitDetails, setBasicHitDetails, agencyUpdatedDetails, setAgencyUpdatedDetails, documentsArray, setDocumentsArray, bankDetails, setBankDetails, address, setAddress, otpValue, setOtpValue, verifyMobileNo, setVerifyMobileNo, otpHidden, setOtpHidden, mobileOTPValidated, setMobileOTPValidated, personalDetailsSectionOk, setPersonalDetailsSectionOk, bankDetailsSectionOk, setBankDetailsSectionOk, agreementDetailsSectionOk, setAgreementDetailsSectionOk, vehicleDetailsSectionOk, setVehicleDetailsSectionOk, shouldActOnSection, setShouldActOnSection, showWorkFlowButtons, showClarificationButton, enableSaveSubmitButtons, stakeHolderDetails, showCommentSection, commentsData, setCommentsData, registerByScruOtpValidated, comments, setComments, enableFieldFunction, currentPage, buttonAction, setCurrentPage, setButtonAction, errorMessage, setErrorMessage, expandedSection, setExpandedSection, setCallUpdateApi, callWorkFlowApi, regScruResourceUpdate, setRegScruResourceUpdate } = useHitContextData();
    const navigate = useNavigate();
    const uuid = localStorage.getItem('uuid');
    const { t } = useTranslation();
    const [logModalOpen, setLogModalOpen] = useState(false);
    const handleLogModalOpen = () => setLogModalOpen(true);
    const handleConfirmLogModalClose = () => setLogModalOpen(false);
    let agreementComments = comments?.filter((item) => item.sectionName === "agreement_details");
    let vehicleComments = comments?.filter((item) => item.sectionName === "vehicle_details");
    const [characterLimit] = useState(300);
    const [agreementComment, setAgreementComment] = useState("");
    const [vehicleComment, setVehicleComment] = useState("");
    const [stakeholderMaster, setStakeholderMaster] = useState();
    const [addEdit, setAddEdit] = useState();
    const [driverHarvesterDetails, setDriverHarvesterDetails] = useState();
    const [driverHarvester, setDriverHarvester] = useState();
    const [vehicleItemDetails, setVehicleItemDetails] = useState();
    const decoded = jwt(getLocalStorageItem('id_token'));
    const [logModalOpen2, setLogModalOpen2] = useState(false);
    const handleLogModalOpen2 = () => setLogModalOpen2(true);
    const handleLogModalClose2 = () => setLogModalOpen2(false);

    const [logModalOpen3, setLogModalOpen3] = useState(false);
    const handleLogModalOpen3 = () => setLogModalOpen3(true);
    const handleLogModalClose3 = () => setLogModalOpen3(false);
    const [hidden, setHidden] = useState({
        divPreview: true
    });
    let checkUserDetails = localStorage.getItem('role');

    const onSaveComment = (comment, sectionName, sectionOk) => {
        const commentObject = {
            comment: comment,
            stakeholderMasterId: hitDetails?.stakeHolder?.hitMasters[0]?.regStakeholderMasterId,
            sectionName: sectionName,
            sectionId: hitDetails?.stakeHolder?.hitMasters[0]?.id,
            sectionOk: sectionOk,
            userRole: localStorage.getItem('role'),
            createdBy: decoded.extension_URN ? hitDetails?.stakeHolder?.hitMasters[0]?.regStakeholderMasterId : uuid,
        }
        comment ? insertComment([commentObject], hitDetails?.stakeHolder?.hitMasters[0]?.regStakeholderMasterId, setCommentsData) : toast.error("Please enter comment")
        setAgreementComment("");
        setVehicleComment("");
        setErrorMessage({ ...errorMessage, agreementCommentError: "", vehicleCommentError: "" });
    }

    const commentsColumn = [
        {
            field: 'comment', headerName: t('reg.comments'), width: 330,
            renderCell: (params) => {
                return (
                    <div style={{ wordBreak: "break-all", overflowWrap: "break-word", whiteSpace: "normal", minHeight: "auto" }}>
                        {params.value.split('<br />').map((line, index) => (
                            <>
                                {line}
                                <br />
                            </>
                        ))}
                    </div>
                )
            }
        },
        {
            field: 'createdByName', headerName: t('preReg.name'), width: 200
        },
        {
            field: 'userRole', headerName: t('reg.userRole'), width: 200
        },
        {
            field: 'createdOnFormatted', headerName: t('reg.date'), width: 200,
        },
    ]

    const confirmSubmission = (e, isRegistrationSubmit) => {
        e.preventDefault();
        handleLogModalOpen();
    }

    const handleChange = (e) => {
        setAgencyUpdatedDetails({ ...agencyUpdatedDetails, [e.target.name]: e.target.value });
        if (e.target.name === 'gstNumber') {
            if (e.target.value.length > 0 && VALIDATION.gstNumberValidation(e.target.value.toUpperCase())) {
                setErrorMessage({ ...errorMessage, gstNumberError: '' })
                setAgencyUpdatedDetails({ ...agencyUpdatedDetails, [e.target.name]: e.target.value.toUpperCase() });
            } else setErrorMessage({ ...errorMessage, gstNumberError: 'Invalid GST Number' })
        }
        if (e.target.name === 'hitTradeLicenseNo') {
            if (e.target.value.length > 0) {
                setBasicHitDetails({ ...basicHitDetails, [e.target.name]: e.target.value.toUpperCase().slice(0, 50).replace(/[^a-zA-Z0-9]/gi, '') });
                setErrorMessage({ ...errorMessage, tradeLicenseNoError: '' })
            } else setErrorMessage({ ...errorMessage, tradeLicenseNoError: 'Please enter Trade License No' })
        }
    };

    const handleDateChange = (e, name) => {
        const newDate = e.format(API_DATE_FORMAT);
        setAgencyUpdatedDetails({ ...agencyUpdatedDetails, [name]: newDate })
        if (checkDateValidation(moment(agencyUpdatedDetails.agreementStartDate).format(BASIC_DATE_FORMAT),
            moment(agencyUpdatedDetails.agreementEndDate).format(BASIC_DATE_FORMAT))) {
            setErrorMessage({ ...errorMessage, agreementDateError: DATE_RANGE_ERROR })
        } else setErrorMessage({ ...errorMessage, agreementDateError: '' })
    }

    const handleDateChangeLicense = (e, name) => {
        const newDate = e.format(API_DATE_FORMAT);
        setBasicHitDetails({ ...basicHitDetails, [name]: newDate })
    }

    const addEditVehicleDetails = (e, regStakeholderMaster, addOrEdit, vehicleItem) => {
        e.preventDefault();
        setErrorMessage({ ...errorMessage, manpowerVechicletableError: "" });
        setStakeholderMaster(regStakeholderMaster);
        setAddEdit(addOrEdit);
        setVehicleItemDetails(vehicleItem);
        handleLogModalOpen3();
    }
    const addEditManpowerDetails = (e, regStakeholderMaster, addOrEdit, harvestOrDriverItem, harvesterOrDriver) => {
        e.preventDefault();
        setErrorMessage({ ...errorMessage, manpowerVechicletableError: "" });
        setStakeholderMaster(regStakeholderMaster);
        setAddEdit(addOrEdit);
        setDriverHarvesterDetails(harvestOrDriverItem);
        setDriverHarvester(harvesterOrDriver);
        handleLogModalOpen2();
    }

    const vehicleSubmitCallbackFunction = (vehicleDetail, onClose, addOrEdit) => {
        if (vehicleDetail?.id === null) {
            delete vehicleDetail.id
        }
        let remainingArr;
        if (addOrEdit === "edit") {
            remainingArr = (agencyUpdatedDetails?.hitVehicleDetails)?.filter(item => item.id !== vehicleDetail.id);
        }
        else {
            remainingArr = agencyUpdatedDetails?.hitVehicleDetails
        }
        remainingArr.push(vehicleDetail);
        setAgencyUpdatedDetails({
            ...agencyUpdatedDetails,
            hitVehicleDetails: remainingArr,
            totalVehicleCount: agencyUpdatedDetails?.hitVehicleDetails?.filter((item1) => (item1.isActive === 1 || item1.isActive === 3)).length
        })

        onClose();
    }

    const onDeleteVehicle = (selectedItem) => {
        const updatedVehicles = ((agencyUpdatedDetails.hitVehicleDetails).map((item, index) => {
            if (item.id === selectedItem.id) {
                item.isActive = 0
            }
            return item
        }
        ))
        setAgencyUpdatedDetails({
            ...agencyUpdatedDetails, hitVehicleDetails: updatedVehicles,
            totalVehicleCount: agencyUpdatedDetails?.hitVehicleDetails?.filter((item1) => (item1.isActive === 1 || item1.isActive === 3)).length
        });
    };

    const harvesterSubmitCallbackFunction = (harvesterDetail, onClose, addOrEdit) => {
        if (harvesterDetail?.id === null) {
            delete harvesterDetail.id
        }
        let remainingArr;
        if (addOrEdit === "edit") {
            remainingArr = (agencyUpdatedDetails?.hitHarvesterDetails)?.filter(item => item.id !== harvesterDetail.id);
        }
        else {
            remainingArr = agencyUpdatedDetails?.hitHarvesterDetails
        }
        remainingArr.push(harvesterDetail);
        setAgencyUpdatedDetails({
            ...agencyUpdatedDetails,
            hitHarvesterDetails: remainingArr,
            totalManpower: agencyUpdatedDetails?.hitDriverDetails?.filter((item1) => (item1.isActive === 1 || item1.isActive === 3)).length + agencyUpdatedDetails?.hitHarvesterDetails?.filter((item1) => item1.isActive === 1).length
        })
        onClose();
    }
    const onDeleteHarvester = (selectedItem) => {
        const updatedHarvesters = ((agencyUpdatedDetails.hitHarvesterDetails).map((item, index) => {
            if (item.id === selectedItem.id) {
                item.isActive = 0
            }
            return item
        }
        ))
        setAgencyUpdatedDetails({
            ...agencyUpdatedDetails, hitHarvesterDetails: updatedHarvesters,
            totalManpower: agencyUpdatedDetails?.hitDriverDetails?.filter((item1) => (item1.isActive === 1 || item1.isActive === 3)).length + agencyUpdatedDetails?.hitHarvesterDetails?.filter((item1) => item1.isActive === 1).length,
        });
    };
    // useEffect(() => {
    //     setHitMaster({
    //         ...hitMaster,
    //         totalManpower: hitMaster?.hitDriverDetails?.filter((item1) => (item1.isActive === 1 || item1.isActive === 3)).length + hitMaster?.hitHarvesterDetails?.filter((item1) => item1.isActive === 1).length,
    //         totalVehicleCount: hitMaster?.hitVehicleDetails?.filter((item1) => (item1.isActive === 1 || item1.isActive === 3)).length
    //     })
    // }, [hitMaster?.hitDriverDetails, hitMaster?.hitVehicleDetails, hitMaster?.hitHarvesterDetails]);


    const driverSubmitCallbackFunction = (driverDetail, onClose, addOrEdit) => {
        if (driverDetail?.id === null) {
            delete driverDetail.id
        }
        let remainingArr;
        if (addOrEdit === "edit") {
            remainingArr = (agencyUpdatedDetails?.hitDriverDetails)?.filter(item => item.id !== driverDetail.id);
        }
        else {
            remainingArr = agencyUpdatedDetails?.hitDriverDetails
        }
        remainingArr.push(driverDetail);
        setAgencyUpdatedDetails({
            ...agencyUpdatedDetails, hitDriverDetails: remainingArr,
            totalManpower: agencyUpdatedDetails?.hitDriverDetails?.filter((item1) => (item1.isActive === 1 || item1.isActive === 3)).length + agencyUpdatedDetails?.hitHarvesterDetails?.filter((item1) => item1.isActive === 1).length
        })
        onClose();
    }
    const onDeleteDriver = (selectedItem) => {
        const updatedDrivers = ((agencyUpdatedDetails?.hitDriverDetails).map((item, index) => {
            if (item.id === selectedItem.id) {
                item.isActive = 0
            }
            return item
        }
        ))
        setAgencyUpdatedDetails({
            ...agencyUpdatedDetails, hitDriverDetails: updatedDrivers,
            totalManpower: agencyUpdatedDetails?.hitDriverDetails?.filter((item1) => (item1.isActive === 1 || item1.isActive === 3)).length + agencyUpdatedDetails?.hitHarvesterDetails?.filter((item1) => item1.isActive === 1).length,
        });
    };

    const onUploadCallBack = (docArray) => {
        setDocumentsArray(docArray);
    }

    const driverCol = [
        { field: 'driverName', headerName: t('reg.fullName'), width: 150 },
        // { field: 'yearsOfExp', headerName: 'Experience', width: 90 },
        { field: 'driverLicenseId', headerName: t('reg.licenseNo'), width: 150 },
        {
            field: t('reg.actions'), width: 100,
            renderCell: (params) => {
                return (
                    <>
                        <Tooltip title="Edit"><IconButton color="primary" onClick={(e) => addEditManpowerDetails(e, hitDetails?.stakeHolder?.hitMasters[0], "edit", params.row, "Driver")} disabled={!enableFieldFunction(shouldActOnSection.vehicle_details, false)}><EditIcon/></IconButton></Tooltip>
                        <Tooltip title="Delete"><IconButton color="error" onClick={() => onDeleteDriver(params.row)} disabled={!enableFieldFunction(shouldActOnSection.vehicle_details, false)} component="label">
                            <DeleteIcon />
                        </IconButton>
                        </Tooltip>
                    </>
                )
            }
        },
    ];
    const harvesterCol = [
        { field: 'harvesterName', headerName: t('reg.fullName'), width: 150 },
        {
            field: 'isTrainingCompleted', headerName: t('reg.trainingStatus'), width: 150,
            valueFormatter: (params) => {
                if (params.value === true) {
                    return 'Yes';
                }
                else {
                    return 'No';
                }
            },

        },
        {
            field: t('reg.actions'), width: 100,
            renderCell: (params) => {
                return (
                    <>
                        <Tooltip title="Edit"><IconButton color="primary" onClick={(e) => addEditManpowerDetails(e, hitDetails?.stakeHolder?.hitMasters[0], "edit", params.row, "Harvester")} disabled={!enableFieldFunction(shouldActOnSection.vehicle_details, false)}><EditIcon/></IconButton></Tooltip>
                        <Tooltip title="Delete"><IconButton color="error" onClick={() => onDeleteHarvester(params.row)} disabled={!enableFieldFunction(shouldActOnSection.vehicle_details, false)} component="label">
                            <DeleteIcon />
                        </IconButton>
                        </Tooltip>
                    </>
                )
            }
        },
    ];
    const vehicleCol = [
        { field: 'vehicleType', headerName: t('preReg.vehicleType'), width: 150 },
        { field: 'registrationNo', headerName: t('reg.registrationNo'), width: 150 },
        {
            field: 'grossVehicleWeight', headerName: t('reg.grossWeightinKg'), width: 150,
            valueGetter: (params) => {
                return params.row.grossVehicleWeight + ' ' + "Kg"
            }
        },
        {
            field: 'vehicleCapacity', headerName: t('reg.vehicleCapacityinKg'), width: 170,
            valueGetter: (params) => {
                return params.row.grossVehicleWeight - params.row.unladenWeight + ' ' + "Kg"
            }
        },
        { field: 'insuranceNo', headerName: t('reg.insuranceNo'), width: 150 },
        {
            field: t('reg.actions'), width: 120,
            renderCell: (params) => {
                return (
                    <>
                        <Tooltip title="Edit"><IconButton color="primary" onClick={(e) => addEditVehicleDetails(e, hitDetails?.stakeHolder?.hitMasters[0], "edit", params.row)} disabled={!enableFieldFunction(shouldActOnSection.vehicle_details, false)}><EditIcon /></IconButton></Tooltip>
                        <Tooltip title="Delete"><IconButton color="error" onClick={() => onDeleteVehicle(params.row)} disabled={!enableFieldFunction(shouldActOnSection.vehicle_details, false)} component="label">
                            <DeleteIcon />
                        </IconButton>
                        </Tooltip>
                    </>
                )
            }
        },
    ];

    return (
        <>
            {agencyUpdatedDetails && <>
                <Grid item xs={12}>
                    <Accordion mt={1} expanded={expandedSection === "agreement"}
                        onChange={(event, expanded) => {
                            setExpandedSection(expanded ? "agreement" : "");
                        }}>
                        <AccordionSummary sx={{ flexDirection: 'row-reverse', backgroundColor: showCommentSection && !regScruResourceUpdate ? (agreementDetailsSectionOk ? "#E9FBF0" : "#FFEBEE") : "FFFFFF" }}
                            expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}
                        >
                            <Stack ml={2} display="flex" alignItems="center" direction="row">
                                {showCommentSection && !regScruResourceUpdate && (agreementDetailsSectionOk ? <TickIcon sx={{ fontSize: 20, color: "#64dd17", marginRight: "1vh" }} /> : <CrossIcon sx={{ fontSize: 20, color: "#f44336", marginRight: "1vh" }} />)}
                                <Typography variant="subtitle1">{t('preReg.licenseAgreementDetails')}</Typography>
                            </Stack>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Grid container pr={4} pb={3} spacing={2} sx={{ backgroundColor: showCommentSection && !regScruResourceUpdate ? (agreementDetailsSectionOk ? "#E9FBF0" : "#FFEBEE") : "FFFFFF", width: "103.5%" }}>
                               
                            <Grid item xs={6} mt={1}>
                                    <TextField fullWidth
                                        required
                                        error={errorMessage.tradeLicenseNoError}
                                        helperText={errorMessage.tradeLicenseNoError}
                                        type="text"
                                        label={t('reg.tradeLicenseNo')}
                                        name="hitTradeLicenseNo"
                                        value={basicHitDetails?.hitTradeLicenseNo}
                                        onChange={(e) => handleChange(e)}
                                        InputProps={{
                                            maxLength: 20,
                                            style: { textTransform: "uppercase" }
                                        }}

                                        disabled={!enableFieldFunction(shouldActOnSection.agreement_details, false)} />
                                    <FileUploadMUI key="TransportationTradeLicense"
                                        documentList={documentsArray}
                                        documentType="TransportationTradeLicense"
                                        callBackDocumentUpload={onUploadCallBack}
                                        stakeholderDetailId={hitDetails?.stakeHolder?.hitMasters[0]?.regStakeholderMasterId}
                                        title={t('reg.uploadTradeLicenseDoc')}
                                        stakeHolderType="hit"
                                        disabled={!enableFieldFunction(shouldActOnSection.agreement_details, false)}
                                        errorMessage={errorMessage}
                                        setErrorMessage={setErrorMessage}
                                        documentError="tradeLicenseDocError"
                                    />
                                    {/* <div className='mandatory_field'>{errorMessage.tradeLicenseDocError}</div> */}
                                </Grid>
                                <Grid item xs={6} mt={1}>
                                    <FormControl fullWidth>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DesktopDatePicker
                                                required
                                                error={errorMessage.agreementSatrtDateError}
                                                helperText={errorMessage.agreementSatrtDateError}
                                                inputFormat="DD/MM/YYYY"
                                                label={t('reg.validTill')}
                                                minDate={moment(new Date()).format(API_DATE_FORMAT)}
                                                value={basicHitDetails.tradeLicenseEndDate ? moment(new Date((basicHitDetails.tradeLicenseEndDate))).format(BASIC_DATE_FORMAT) : moment(new Date).format(BASIC_DATE_FORMAT)}
                                                name="tradeLicenseEndDate"
                                                onChange={(e) => handleDateChangeLicense(e, "tradeLicenseEndDate")}
                                                disabled={!enableFieldFunction(shouldActOnSection.agreement_details, false)}
                                                renderInput={(params) => <TextField {...params} />}
                                                sx={{ paddingRight: '3%' }}
                                            />
                                        </LocalizationProvider>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField fullWidth
                                        required
                                        error={errorMessage.labourLicenseNoError}
                                        helperText={errorMessage.labourLicenseNoError}
                                        type="text"
                                        label={t('reg.labourLicenseNo')}
                                        name="hitLabourLicenseNo"
                                        value={basicHitDetails?.hitLabourLicenseNo}
                                        onChange={(e) => handleChange(e)}
                                        inputProps={{
                                            maxLength: 20,
                                            style: { textTransform: "uppercase" }
                                        }}
                                        disabled={!enableFieldFunction(shouldActOnSection.agreement_details, false)} />
                                    <FileUploadMUI key="LabourLicence"
                                        documentList={documentsArray}
                                        documentType="LabourLicence"
                                        callBackDocumentUpload={onUploadCallBack}
                                        stakeholderDetailId={hitDetails?.stakeHolder?.hitMasters[0]?.regStakeholderMasterId}
                                        title={t('reg.uploadLabourLicenseDoc')}
                                        stakeHolderType="hit"
                                        disabled={!enableFieldFunction(shouldActOnSection.agreement_details, false)}
                                        errorMessage={errorMessage}
                                        setErrorMessage={setErrorMessage}
                                        documentError="labourLicenseDocError"
                                    />
                                    {/* <div className='mandatory_field'>{errorMessage.labourLicenseDocError}</div> */}
                                </Grid>
                                <Grid item xs={6}>
                                    <FormControl fullWidth>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DesktopDatePicker label={t('reg.validTill')}
                                                inputFormat="DD/MM/YYYY"
                                                value={basicHitDetails.labourLicenseEndDate ? moment(new Date((basicHitDetails.labourLicenseEndDate))).format(BASIC_DATE_FORMAT) : moment(new Date).format(BASIC_DATE_FORMAT)}
                                                name="labourLicenseEndDate"
                                                onChange={(e) => handleDateChangeLicense(e, "labourLicenseEndDate")}
                                                disabled={!enableFieldFunction(shouldActOnSection.agreement_details, false)}
                                                minDate={moment(new Date()).format(API_DATE_FORMAT)}
                                                renderInput={(params) => <TextField {...params} />}
                                            />
                                        </LocalizationProvider>

                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} lg={6}>
                                    <TextField fullWidth disabled={!enableFieldFunction(shouldActOnSection.agreement_details, false)}
                                        required
                                        error={errorMessage.gstNumberError}
                                        helperText={errorMessage.gstNumberError}
                                        type="text" label={t('preReg.gstNo')}
                                        name="gstNumber"
                                        value={agencyUpdatedDetails?.gstNumber}
                                        onChange={(e) => handleChange(e)}
                                        inputProps={{
                                            maxLength: 15,
                                            style: {
                                                textTransform: "uppercase"
                                            }
                                        }
                                        } />
                                    <FileUploadMUI key="GST"
                                        documentList={documentsArray}
                                        documentType="GST"
                                        callBackDocumentUpload={onUploadCallBack}
                                        stakeholderDetailId={hitDetails?.stakeHolder?.hitMasters[0]?.regStakeholderMasterId}
                                        title={t('preReg.uploadGst')}
                                        stakeHolderType="hit"
                                        disabled={!enableFieldFunction(shouldActOnSection.agreement_details, false)}
                                        errorMessage={errorMessage}
                                        setErrorMessage={setErrorMessage}
                                        documentError="gstDocError"
                                    />
                                    {/* <div className='mandatory_field'>{errorMessage.gstDocError}</div> */}
                                </Grid>
                                <Grid item xs={6} lg={3}>
                                    <FormControl fullWidth>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DesktopDatePicker
                                                inputFormat="DD/MM/YYYY"
                                                label={t('reg.startDate')}
                                                value={agencyUpdatedDetails?.agreementStartDate ? moment(new Date((agencyUpdatedDetails?.agreementStartDate))).format(BASIC_DATE_FORMAT) : moment(new Date).format(BASIC_DATE_FORMAT)}
                                                name="agreementStartDate"
                                                onChange={(e) => handleDateChange(e, "agreementStartDate")}
                                                disabled={!enableFieldFunction(shouldActOnSection.agreement_details, false)}
                                                renderInput={(params) => <TextField {...params} />}
                                                sx={{ minWidth: 750 }} />
                                        </LocalizationProvider>
                                        <FormHelperText>{errorMessage.agreementDateError}</FormHelperText>
                                    </FormControl>
                                    <FileUploadMUI key="LOI_ABRPLAgreement"
                                        documentList={documentsArray}
                                        documentType="LOI_ABRPLAgreement"
                                        callBackDocumentUpload={onUploadCallBack}
                                        stakeholderDetailId={hitDetails?.stakeHolder?.hitMasters[0]?.regStakeholderMasterId}
                                        title={t('preReg.uploadLoiAgreement')}
                                        stakeHolderType="hit"
                                        disabled={!enableFieldFunction(shouldActOnSection.agreement_details, false)}
                                        errorMessage={errorMessage}
                                        setErrorMessage={setErrorMessage}
                                        documentError="agreementDocError"
                                    />
                                    {/* <div className='mandatory_field'>{errorMessage.agreementDocError}</div> */}
                                </Grid>
                                <Grid item xs={6} lg={3}>
                                    <FormControl fullWidth>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DesktopDatePicker
                                                inputFormat="DD/MM/YYYY"
                                                label={t('reg.endDate')}
                                                minDate={moment(new Date()).format(API_DATE_FORMAT)}
                                                value={agencyUpdatedDetails?.agreementEndDate ? moment(new Date((agencyUpdatedDetails?.agreementEndDate))).format(BASIC_DATE_FORMAT) : moment(new Date).format(BASIC_DATE_FORMAT)}
                                                name="agreementEndDate"
                                                onChange={(e) => handleDateChange(e, "agreementEndDate")}
                                                disabled={!enableFieldFunction(shouldActOnSection.agreement_details, false)}
                                                renderInput={(params) => <TextField {...params} />}
                                                sx={{ minWidth: 750 }}
                                            />
                                        </LocalizationProvider>
                                        <FormHelperText>{errorMessage.agreementDateError}</FormHelperText>
                                    </FormControl>
                                </Grid>
                            </Grid>
                            {showCommentSection && <><Grid container direction="row" mt={2} mb={2} alignItems="center" spacing={2}>
                                <Grid item xs={7}> <TextField sx={{ width: "100%" }}
                                    label={t('reg.comment')}
                                    helperText={errorMessage.agreementCommentError}
                                    error={errorMessage.agreementCommentError}
                                    name="comment"
                                    inputProps={{
                                        maxLength: 300,
                                    }}
                                    multiline
                                    disabled={!shouldActOnSection.agreement_details || viewOnly}
                                    value={agreementComment}
                                    onChange={(e) => setAgreementComment(VALIDATION.noSpecialCharacterValidation(e.target.value))}
                                />
                                    <div style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '1vh' }}>
                                        <Badge bg={`${agreementComment?.length > characterLimit ? 'danger' : 'primary'}`}>{agreementComment?.length}/{characterLimit}</Badge>
                                    </div>
                                </Grid><Grid item xs={2}>
                                    <FormGroup>
                                        <FormControlLabel control={<Switch disabled={!shouldActOnSection.agreement_details || viewOnly} checked={agreementDetailsSectionOk}
                                            onChange={(e) => setAgreementDetailsSectionOk(e.target.checked)} />} label={<Typography variant="subtitle2">
                                                {t('reg.detailsOk')}?
                                            </Typography>} />
                                    </FormGroup>
                                </Grid><Grid item xs={3}>
                                    <Button variant="contained" disabled={!shouldActOnSection.agreement_details || viewOnly}
                                        onClick={() => onSaveComment(agreementComment, "agreement_details", agreementDetailsSectionOk)}
                                        startIcon={<CommentIcon/>}
                                    >
                                        {t('preReg.addComment')}
                                    </Button>
                                </Grid>
                            </Grid>
                                <div>
                                    <Accordion mt={1} >
                                        <AccordionSummary
                                            expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}
                                        >
                                            <Typography variant="subtitle1" ml={2}>{t('reg.commentHistory')}</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Box style={{ height: 300, width: '100%' }}>
                                                <DataGrid
                                                    rows={agreementComments ? agreementComments : []}
                                                    columns={commentsColumn}
                                                    pageSize={10}
                                                    getRowHeight={() => 'auto'} />
                                            </Box>
                                        </AccordionDetails>
                                    </Accordion>
                                </div></>}
                        </AccordionDetails>

                    </Accordion>
                </Grid>
                <Grid item xs={12}>
                    <Accordion mt={1} expanded={expandedSection === "vehicle"}
                        onChange={(event, expanded) => {
                            setExpandedSection(expanded ? "vehicle" : "");
                        }}>
                        <AccordionSummary sx={{ flexDirection: 'row-reverse', backgroundColor: showCommentSection && !regScruResourceUpdate ? (vehicleDetailsSectionOk ? "#E9FBF0" : "#FFEBEE") : "FFFFFF" }}
                            expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}
                        >
                            <Stack ml={2} display="flex" alignItems="center" direction="row">
                                {showCommentSection && !regScruResourceUpdate && (vehicleDetailsSectionOk ? <TickIcon sx={{ fontSize: 20, color: "#64dd17", marginRight: "1vh" }} /> : <CrossIcon sx={{ fontSize: 20, color: "#f44336", marginRight: "1vh" }} />)}
                                <Typography variant="subtitle1">Vehicle & Manpower Details</Typography>
                            </Stack>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Grid container pr={4} pb={3} spacing={2} sx={{ backgroundColor: showCommentSection && !regScruResourceUpdate ? (vehicleDetailsSectionOk ? "#E9FBF0" : "#FFEBEE") : "FFFFFF", width: "103.5%" }}>
                              
                            <Grid item xs={6} lg={3}>
                                <TextField fullWidth label={t('reg.totalVehicleCount')} disabled type="text" name="totalVehicleCount" value={agencyUpdatedDetails?.totalVehicleCount || ''} onChange={(e) => handleChange(e)} inputProps={{
                                    maxLength: 10
                                }} />
                            </Grid>
                            <Grid item xs={6} lg={3}>
                                <TextField fullWidth label={t('reg.totalManpower')} disabled type="text" name="totalManpower" defaultValue={agencyUpdatedDetails?.totalManpower} onChange={(e) => handleChange(e)} inputProps={{
                                    maxLength: 10
                                }} />

                            </Grid>
                            <Grid item xs={12} >
                                <div className='mandatory_field'>{errorMessage.manpowerVechicletableError}</div>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} justifyContent="flex-start" mb={1}>
                                    <Button onClick={(e) => addEditManpowerDetails(e, hitDetails?.stakeHolder?.hitMasters[0], "add", null)} disabled={!enableFieldFunction(shouldActOnSection.vehicle_details, false)} variant="contained" startIcon={<AddIcon />}>
                                        {t('reg.addManpowerDetails')}
                                    </Button>
                                </Stack>
                            </Grid>
                            <Grid item xs={12} lg={6}>
                                <Grid item xs={12}>
                                    <Typography variant="h6" gutterBottom>
                                        {t('reg.driverDetails')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Box style={{ height: 300, width: '100%' }}>
                                        {/* {console.log("driver",hitMaster?.hitDriverDetails?.filter(item => (item.isActive === 1 || item.isActive === 3)))} */}
                                        <DataGrid
                                            // autoHeight
                                            getRowHeight={() => 'auto'}
                                            rows={agencyUpdatedDetails?.hitDriverDetails?.filter(item => (item.isActive === 1 || item.isActive === 3))}
                                            columns={driverCol}
                                            pageSize={10}
                                            components={{ Toolbar: QuickSearchToolbar }}
                                        />

                                    </Box>
                                </Grid>
                            </Grid>

                            <Grid item xs={12} lg={6}>
                                <Grid item xs={12}>
                                    <Typography variant="h6" gutterBottom>
                                        {t('reg.harvesterDetails')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Box style={{ height: 300, width: '100%' }}>
                                        <DataGrid
                                            // autoHeight
                                            getRowHeight={() => 'auto'}
                                            rows={agencyUpdatedDetails?.hitHarvesterDetails?.filter(item => (item.isActive === 1 || item.isActive === 3))}
                                            columns={harvesterCol}
                                            pageSize={10}
                                            components={{ Toolbar: QuickSearchToolbar }}
                                        />
                                    </Box>
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography variant="h6" gutterBottom>
                                    {t('reg.vehicleDetails')}
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} justifyContent="flex-start" mb={1}>
                                    <Button onClick={(e) => addEditVehicleDetails(e, hitDetails?.stakeHolder?.hitMasters[0], "add", null)} disabled={!enableFieldFunction(shouldActOnSection.vehicle_details, false)} variant="contained" startIcon={<AddIcon />}>
                                        {t('reg.addVehicleDetails')}
                                    </Button>
                                </Stack>
                                <Box style={{ height: 400, width: '100%' }}>
                                    <DataGrid
                                        //autoHeight
                                        getRowHeight={() => 'auto'}
                                        rows={agencyUpdatedDetails?.hitVehicleDetails?.filter(item => (item.isActive === 1 || item.isActive === 3))}
                                        columns={vehicleCol}
                                        pageSize={10}
                                        components={{ Toolbar: QuickSearchToolbar }}
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                        {showCommentSection && <><Grid container direction="row" mt={2} mb={2} alignItems="center" spacing={2}>
                            <Grid item xs={7}> <TextField sx={{ width: "100%" }}
                                label={t('reg.comment')}
                                helperText={errorMessage.vehicleCommentError}
                                error={errorMessage.vehicleCommentError}
                                name="comment"
                                inputProps={{
                                    maxLength: 300,
                                }}
                                multiline
                                disabled={!shouldActOnSection.vehicle_details || viewOnly}
                                value={vehicleComment}
                                onChange={(e) => setVehicleComment(VALIDATION.noSpecialCharacterValidation(e.target.value))}
                            /><div style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '1vh' }}>
                                    <Badge bg={`${vehicleComment?.length > characterLimit ? 'danger' : 'primary'}`}>{vehicleComment?.length}/{characterLimit}</Badge>
                                </div>
                            </Grid>
                            <Grid item xs={2}>
                                <FormGroup>
                                    <FormControlLabel control={<Switch disabled={!shouldActOnSection.vehicle_details || viewOnly} checked={vehicleDetailsSectionOk}
                                        onChange={(e) => setVehicleDetailsSectionOk(e.target.checked)} />} label={<Typography variant="subtitle2">
                                            {t('reg.detailsOk')}?
                                        </Typography>} />
                                </FormGroup>
                            </Grid>
                            <Grid item xs={3}>
                                <Button variant="contained" disabled={!shouldActOnSection.vehicle_details || viewOnly}
                                    onClick={() => onSaveComment(vehicleComment, "vehicle_details", vehicleDetailsSectionOk)}
                                    startIcon={<CommentIcon/>}
                                >
                                    {t('preReg.addComment')}
                                </Button>
                            </Grid>
                        </Grid>
                            <div>
                                <Accordion mt={1} >
                                    <AccordionSummary
                                        expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}
                                    >
                                        <Typography variant="subtitle1" ml={2}>{t('reg.commentHistory')}</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Box style={{ height: 300, width: '100%' }}>
                                            <DataGrid
                                                rows={vehicleComments ? vehicleComments : []}
                                                columns={commentsColumn}
                                                pageSize={10}
                                                getRowHeight={() => 'auto'} />
                                        </Box>
                                    </AccordionDetails>
                                </Accordion>
                            </div></>}
                    </AccordionDetails>

                </Accordion>
            </Grid></>}
            <Dialog maxWidth='md' fullWidth open={logModalOpen2}>
                <DialogContent>
                    <DriverPopupHit
                        regStakeholderMaster={stakeholderMaster}
                        addOrEdit={addEdit}
                        harvesterSubmitCallbackFunction={harvesterSubmitCallbackFunction}
                        driverSubmitCallbackFunction={driverSubmitCallbackFunction}
                        harvestOrDriverItem={driverHarvesterDetails}
                        harvesterOrDriver={driverHarvester}
                        onClose={handleLogModalClose2}
                    />
                </DialogContent>
            </Dialog>
            <Dialog maxWidth='md' fullWidth open={logModalOpen3}>
                <DialogContent>
                    <VehiclePopupHit
                        onClose={handleLogModalClose3}
                        regStakeholderMaster={stakeholderMaster}
                        vehicleSubmitCallbackFunction={vehicleSubmitCallbackFunction}
                        addOrEdit={addEdit}
                        vehicleItem={vehicleItemDetails}
                    />
                </DialogContent>
            </Dialog>
            {/* <ConfirmationPopover action="Submit" onOpen={logModalOpen} onConfirm={onSubmitClick} onClose={handleConfirmLogModalClose} /> */}
            </>
    )

}
export default AgencyDetails;

